<template>
    <div class="library padded">
        
        <h2>Библиотека</h2>
        <!-- <btn label="Создать материал" i="plus" @press="createPost()" size="medium" /> -->
        <i-list-editor :scheme="scheme" :value="lib" @save="save" v-if="Id"/>
    </div>
</template>
<script>
export default {
    name: 'library',
    methods: {
        save() {
            let { Id, lib } = this;
            this.$http.post("content/universals", { _id:Id, meta: { lib } }).then((res) => {
                alert("Сохранено");
            })
        }
    },
    async beforeMount() {
        let res = await this.$http.get("content/universals");

        let found = res.body.universals.find(p => p.type === 'lib');
        this.lib = found.meta.lib;
        this.Id = found._id;

    },
    data() {
        return {
            Id: "",
            lib: [],
            scheme: {
                "title": {
                    type: "string",
                    label: "Название"
                },
                /*"description": {
                    type: "string",
                    label: "Описание",
                    required: true
                },
                "author": {
                    type: "string",
                    label: "Автор",
                    required: true
                },*/
                "preview": {
                    type: "image",
                    label: "Превью",
                    required: true,
                    index: 1
                },
                "doc": {
                    type: "file",
                    label: "Материал",
                    required: true
                },
                "type": {
                    type: "options",
                    label: "Тип",
                    required: true,
                    options: [{ value: "journal", label: "Журнал" }, { value: "report", label: "Доклад" }],
                    index: 3
                },
                /*"date": {
                    type: "date",
                    label: "Дата",
                    required: true
                },*/
                "year": {
                    type: "options",
                    label: "Год",
                    index: 2,
                    required: true,
                    options: (() => {
                        let arr = [];
                        for (let i = 2000; i < 2024; i++) {
                            arr.push({ label: i, value: i });
                        }
                        return arr;
                    })()
                },
                "lang": {
                    type: "multi-select",
                    label: "Язык",
                    options: [{ value: "kz", label: "kz" }, { value: "ru", label: "ru" }, { value: "en", label: "en" }]
                }
            }
        }
    }
}
</script>
<style lang="css" scoped>
</style>